export class Percentage {
    static options() {
        return [
            {
                value: '0',
                text: '0%'
            },
            {
                value: '25',
                text: '25%'
            },
            {
                value: '50',
                text: '50%'
            },
                        {
                value: '75',
                text: '75%'
            },
                        {
                value: '100',
                text: '100%'
            }                        
        ];
    }
}


// WEBPACK FOOTER //
// ./src/helpers/percentage-options.js